import { useTranslation } from '@pancakeswap/localization'
import { Flex, Heading } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { DEX_LABEL, DexId, VersionParam } from 'state/infoHub/hooks'

const Row = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px 16px;
  margin-bottom: 12px;
`

/** One line for set (b), the public pool statistics of one DEX; the data state sits on the same line, no paragraph under it. */
export const MarketHeader: React.FC<React.PropsWithChildren<{ dex: DexId; version: VersionParam }>> = ({ dex, version, children }) => {
  const { t } = useTranslation()
  return (
    <Row>
      <Heading scale="md" as="h2" id="market-stats-title">
        {DEX_LABEL[dex]} {version === 'all' ? t('pools') : `${version.toUpperCase()} ${t('pools')}`}
      </Heading>
      {children}
    </Row>
  )
}
export default MarketHeader
